import { z } from 'zod';

export const schemaConsorsDateYYYYMM = z.string().regex(/^(19|20)\d\d[-](0[1-9]|1[012])$/, 'Invalid characters');
export type SchemaConsorsDateYYYYMM = z.infer<typeof schemaConsorsDateYYYYMM>;
